export default "<div class=\"not-found-page-text d-flex justify-content-center\">\n  <h1>Pagina non trovata</h1>\n</div>\n";